import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Provider } from 'react-redux';
import store from './redux-toolkit/store/store';
import Sidebar from './components/Sidebar';
import 'remixicon/fonts/remixicon.css';
import "react-datepicker/dist/react-datepicker.css";
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import { BrowserRouter } from 'react-router-dom';
import ApplicationLogout from './components/ApplicationLogout.jsx'
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <ApplicationLogout>
        <App />
      </ApplicationLogout>
    </BrowserRouter>

    <ToastContainer />
  </Provider>
);


